import {
  ChannelDetails,
  ChannelTypeEnum,
  getUserId,
  getWorkspaceId,
  store,
} from '@zonofi/seller-rtk-store';

const ZonoBotUserIds = {
  ledgerBot: 'e49f0374-7f51-40ce-ae67-4f64f9e3d234',
  setupBot: '8d828c29-9219-47cf-be5b-ba937dd7dc8c',
  orderBot: 'fccfcd59-9f4d-4992-99f6-8871383acc0c',
  productBot: '2fb643a8-d547-4633-bed3-e6a76fd7b99b',
  claimBot: '8d828c29-9219-47cf-be5b-ba937dd7dc8c',
  invoiceBot: 'f3a21459-1a08-41b4-bfda-f304e95c7b14',
};

export const isOwnMessage = (uuid: string, channel?: ChannelDetails) => {
  const userId = getUserId(store.getState());
  const workspaceId = getWorkspaceId(store.getState());
  const memberIds: string[] = [];
  if (channel && channel.type === ChannelTypeEnum.CUSTOMERTHREAD) {
    (channel.teamMembers || []).forEach((x) => memberIds.push(x?.userId || ''));
  }
  const botUserIds = Object.values(ZonoBotUserIds);
  const allIds = [userId, workspaceId, ...memberIds, ...botUserIds];
  return allIds.includes(uuid);
};
